import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tool-loader',
    template: `
  <div class="loading-container" [style.position]="positionUnset ? 'unset' : 'relative'" [style.height]="positionUnset ? '100%' : 'unset'" [class.flex-col-full]="positionUnset">
    @if(isLoading) {
      <div class="loading-indicator">
            <div class="loading-indicator__centerer">
                <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem !important"></i>
            </div>
      </div>
    }
    <ng-content></ng-content>
  </div>
  `,
    styles: [`
    :host {
      display: block;
      height: 100%;
    }

    .loading-container {
        position: relative;
    }

    .flex-col-full {
      display: flex;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;
    }

    .loading-indicator {
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 50;
      opacity: 60%;
    }

    .loading-indicator__centerer {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
  `],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolLoaderComponent {
  @Input()
  isLoading = false;

  @Input()
  positionUnset? : boolean = false;

}
